import { useEffect, useState } from 'react'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Typography,
} from '@mui/material'

import { FAQDetail } from '../constants/FAQ'
import { styles } from './SupportSubAccordion.styles'

export interface SupportSubAccordionProps {
	categoryDetails: FAQDetail[]
	parentOpen: boolean
}

export const SupportSubAccordion = ({
	categoryDetails,
	parentOpen,
}: SupportSubAccordionProps) => {
	const [activeDropdown, setActiveDropdown] = useState<number>(-1)

	useEffect(() => {
		if (!parentOpen) {
			setActiveDropdown(-1)
		}
	}, [parentOpen])

	const handleClick = (idx: number) => {
		if (activeDropdown === idx) {
			setActiveDropdown(-1)
		} else {
			setActiveDropdown(idx)
		}
	}

	return (
		<Box sx={styles.container}>
			{categoryDetails.map((detail, idx) => (
				<Box key={detail.title + idx} onClick={() => handleClick(idx)}>
					<Accordion
						elevation={0}
						sx={styles.accordion}
						expanded={activeDropdown === idx}
					>
						<AccordionSummary
							sx={styles.accordionSummary}
							expandIcon={
								<ExpandMoreIcon sx={styles.expandIcon} />
							}
						>
							<Typography sx={styles.titleTypography}>
								{detail.title}
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							{detail.content.split(/\n\s*\n/).map((para, i) => (
								<Typography
									key={detail.title + '_content_' + i}
									sx={styles.contentTypography}
									paragraph
								>
									{para}
								</Typography>
							))}
							{detail.imageURL && (
								<img
									src={detail.imageURL}
									alt={detail.title}
									style={styles.image}
								/>
							)}
						</AccordionDetails>
					</Accordion>
				</Box>
			))}
		</Box>
	)
}

export default SupportSubAccordion
